<tiime-dialog [isLoading]="isLoading()" (cancel)="cancel()" data-cy="select-contract-dialog">
  <span mat-dialog-title data-cy="select-contract-title">{{ overlayData().title }}</span>
  <mat-dialog-content class="dialog-content" mat-dialog-content>
    <tiime-alert primary>{{ overlayData().alert }}</tiime-alert>
    <app-contracts-container
      [contracts]="overlayData().contracts"
      [canCreateContract]="false"
      emptyLabel="Aucun contrat signé"
      updateStatusDisabled
      (updateContract)="close($event)"
    ></app-contracts-container>
  </mat-dialog-content>
  <mat-dialog-actions class="dialog-actions">
    <button tiime-button color="accent" strocked large (click)="cancel()" data-cy="select-contract-cancel-btn">
      Annuler
    </button>
  </mat-dialog-actions>
</tiime-dialog>
